/**
 * User-facing validation messages for the Business Office notes header
 * buttons' disabling conditions (see `busniessOfficeNotesHeader.tsx`).
 *
 * Each key maps 1:1 to a condition that can disable a button, so the same
 * message can be reused in tooltips, banners, toasts, or help text anywhere
 * in the app.
 *
 * @module boNotesValidationMessages
 */
export enum BoNotesValidationMessages {
  // A save request is already in flight
  SAVE_BO_IN_PROGRESS = "BO notes save in progress",

  // An RPA run is already in progress
  RPA_IN_PROGRESS = "RPA run in progress",

  // RPA has already been triggered for this order
  RPA_ALREADY_TRIGGERED = "RPA already triggered",

  // Any CPT row has an invalid value on a save-blocking field
  CPT_TABLE_HAS_ERRORS = "Invalid CPT table values",

  // No business office notes exist yet
  NO_BO_NOTES = "Business office notes required",

  // No final report comments exist
  NO_FINAL_REPORT_COMMENTS = "Final report comments required",

  // Not every final report comment has a BO status selected
  BO_STATUS_MISSING = "BO status required for every final report comment",

  // EV write-back is in progress or queued
  EV_WRITE_BACK_IN_PROGRESS = "EV write-back in progress",

  // No J-codes are present on the order
  NO_J_CODES = "No J-codes available",
}
